<template>
  <div class="row living-options">
    <language-selector />
    <card-tabs 
      class="col-12 w-100" 
      :tabs="[
        { 
          label: 'Rest',
          id: 'rest',
        },
        { 
          label: 'Category',
          id: 'category',
        },
        { 
          label: 'Live',
          id: 'live',
        },
        { 
          label: 'General',
          id: 'general',
        },
      ]"
      :active-tab="activeTab"
      @tabClick="navigateToTab"
    >
      <template v-slot:rest>
        <SettingsRest />
      </template>
      <template v-slot:category>
        <SettingsCategory />
      </template>
      <template v-slot:live>
        <SettingsLive />
      </template>
      <template v-slot:general>
        <SettingsGeneral />
      </template>
    </card-tabs>   
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { camelCase } from 'lodash'
import CardTabs from '@/components/Cards/TabsCard'
import LanguageSelector from '@/components/LanguageSelector'
import SettingsCategory from './SettingsCategory'
import SettingsGeneral from './SettingsGeneral'
import SettingsLive from './SettingsLive'
import SettingsRest from './SettingsRest'

export default {
  components: { CardTabs, LanguageSelector, SettingsCategory, SettingsGeneral, SettingsLive, SettingsRest },

  computed: {
    ...mapGetters(['langs']),

    activeTab () {
      return camelCase(this.$route.name)
    }
  },

  beforeRouteEnter(to, from, next) {
    if (to.path === '/settings') {
      next('/settings/rest')
    } else {
      next()
    }
  },

  beforeRouteUpdate (to, from, next) {
    if (to.path === '/settings') {
      next('/settings/rest')
    } else {
      next()
    }
  },

  methods: {
    navigateToTab (tab) {
      this.$router.push('/settings/' + tab)
    }
  }
}
</script>
<style lang="scss">

.tag-crm {
  background: #60f454;
  border: 1px solid darken(#60f454, 15%);
  border-radius: 3px;
  display: inline-block;
  font-size: 11px;
  margin: 0 8px 0 0;
  padding: 2px 8px;
}

.dot {
  background: #b8b8b8;
  border: 1px solid darken(#b8b8b8, 15%);
  border-radius: 50%;
  display: inline-block;
  height: 10px;
  margin-right: 6px;
  width: 10px;

  &--crm {
    background: #60f454;
    border: 1px solid darken(#60f454, 15%);
  }
}

.highlight {
  background: rgb(253, 239, 132);
}
</style>